/**
 * @file This file implements the student view footer that is shown when a user is in student view.
 */
import { faChevronDown } from '@fortawesome/free-solid-svg-icons/faChevronDown';
import { faChevronUp } from '@fortawesome/free-solid-svg-icons/faChevronUp';
import { faGlasses } from '@fortawesome/free-solid-svg-icons/faGlasses';
import * as tsx from 'vue-tsx-support';
import { expr } from '@codegrade/utils';
import Collapse from '@/components/Collapse';
import Icon from '@/components/Icon';
// @ts-expect-error This component is not yet typed
import SubmitButton from '@/components/SubmitButton';
import { UserStore } from '@/store';
import * as utils from '@/utils';
import './style.less';
export default tsx.component({
    name: 'student-view-footer',
    /** @returns The data for this component. */
    data() {
        return {
            hideFooter: false,
        };
    },
    computed: {
        /** @returns What the current state of student view is. */
        studentViewState() {
            return UserStore.studentView();
        },
        /** @returns The leave student view button if we can actually leave. */
        leaveStudentViewButton() {
            const state = this.studentViewState;
            return utils.ifOrEmpty(state.tag === 'enabled' && state.canLeave, () => (<SubmitButton submit={async () => ({
                    onAfterSuccess: async () => await UserStore.popRestrictions(),
                })} successAlert={'You have left the student view'} duration={400}>
                    <span class="text-nowrap">Leave Student View</span>
                </SubmitButton>));
        },
        /** @returns The body node of the footer. */
        contentNode() {
            return (<div class="px-3 py-1 d-flex align-items-center student-view-footer-content">
                    <Icon icon={faGlasses}/>
                    <div class="mx-2 flex-grow-1">
                        <div class="font-weight-bold">Student View Enabled</div>
                        <div class="small font-italic">
                            You are now viewing this course as a student. This allows you to inspect
                            and interact with the assignments as a student would.
                        </div>
                    </div>

                    {this.leaveStudentViewButton}
                </div>);
        },
        /** @returns The rendered body if we need to render it. */
        bodyNode() {
            return expr.match(this.studentViewState, 'tag', {
                disabled: utils.emptyVNode,
                enabled: () => (<div class={['student-view-footer border rounded-top']}>
                        <button class="mx-2 px-2 py-1 handle d-inline-block border border-bottom-0 rounded-top" v-cg-toggle="student-view-footer-content-collapse" aria-label={`${this.hideFooter ? 'Show' : 'Hide'} the student view footer`}>
                            <Icon icon={this.hideFooter ? faChevronUp : faChevronDown}/>
                        </button>
                        <Collapse id="student-view-footer-content-collapse" v-model={this.hideFooter}>
                            {this.contentNode}
                        </Collapse>
                    </div>),
            });
        },
    },
    /** @returns The rendered component. */
    render() {
        return this.bodyNode;
    },
});
